module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_RO-0c22b6706ebfa569b73e3bbfa6bc2c79.svg";